<template>
  <div id="page-top-balance">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vx-card>
            <div class="vx-card__title">
              <h4>20 ยูสเซอร์เครดิตสูงสุด</h4>
              <br>
            </div>

            <div class="export-table">
              <vs-table stripe pagination max-items="20" :data="memberData" search>

                <template slot="header">
                  <vs-button class="mr-2" color="primary" :disabled="loading" @click="getTopBalance">
                    <span v-if="loading">
                      <i class="fas fa-spinner fa-spin mr-2"></i>กำลังโหลด...
                    </span>
                    <span v-else>รีเฟรช</span>
                  </vs-button>
                </template>

                <template slot="thead">
                  <vs-th sort-key="rank">อันดับ</vs-th>
                  <vs-th sort-key="member_username">ยูสเซอร์เนม</vs-th>
                  <vs-th sort-key="member_balance">เครดิตคงเหลือ</vs-th>
                  <vs-th sort-key="from_website">เว็บไซต์</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ data[indextr].rank }}</vs-td>
                    <vs-td class="text-danger">
                      <router-link :to="`/member/${data[indextr].member_username}`">{{ data[indextr].member_username }}</router-link>
                    </vs-td>
                    <vs-td>{{ currency(parseFloat(data[indextr].member_balance).toFixed(2)) }}</vs-td>
                    <vs-td>
                      <span class="website-badge" :style="websiteStyle(data[indextr].from_website)">{{ data[indextr].from_website }}</span>
                    </vs-td>
                  </vs-tr>
                </template>

              </vs-table>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios'

export default {
  data () {
    return {
      memberData: [],
      loading: false
    }
  },
  async mounted () {
    await this.getTopBalance()
  },
  methods: {
    async getTopBalance () {
      this.loading = true
      try {
        const response = await axios.get('member/top-balance')
        const list = response.data.data || []
        this.memberData = list.map((item, index) => ({
          ...item,
          rank: index + 1
        }))
      } finally {
        this.loading = false
      }
    },
    currency (amount) {
      if (!amount || amount === 'NaN') {
        amount = 0
      }
      if (typeof amount === 'number') {
        amount = String(amount)
      }
      return amount.replace(/\d(?=(\d{3})+\.)/g, '$&,')
    },
    websiteStyle (website) {
      const colorMap = {
        lalikabet168: '#EA5455', // แดง
        lalikabet66: '#28C76F', // เขียว
        lalikabet88: '#FF9F43' // ส้ม
      }
      return {
        backgroundColor: colorMap[website] || '#7367F0',
        color: '#fff'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.website-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
}
</style>
